// App
import React from 'react';

// Misc / utils
import * as S from './styles';

const SrpContentWrapper = ({
  /** background: enum [backgroundWhite, backgroundGrey]; defaults to `backgroundWhite` */
  background = 'backgroundWhite',
  /** border: enum [borderBottom, borderTop] - adds border to wrapper */
  border,
  /** children: Primary content */
  children,
  /** customHeader: Replaces standard wrapper header */
  customHeader = null,
  /** fluid: should wrapper span full viewport width; defaults to false */
  fluid = false,
  /** identifier: adds id tag to article */
  identifier,
  /** title: title that should be used as wrapper heading */
  title,
}: {
  background?: 'backgroundWhite' | 'backgroundGrey';
  border?: 'borderBottom' | 'borderTop';
  children?: React.ReactNode;
  customHeader?: React.ReactNode;
  fluid?: boolean;
  identifier?: string;
  title?: string;
}) => {
  return (
    <S.ArticleContainer id={identifier} background={background} fluid={fluid} border={border}>
      {customHeader ? (
        customHeader
      ) : (
        <>
          {title ? (
            <S.Header>
              <S.Title>{title}</S.Title>
            </S.Header>
          ) : null}
        </>
      )}
      {children ? children : <p>Loading...</p>}
    </S.ArticleContainer>
  );
};

export default SrpContentWrapper;
